module.exports = __webpack_public_path__ + "static/media/backbutton.3c0d526e.svg";